<template>
  <div class="loading" v-if="isPropertyLoading || isLoading || isUserLoading">
    <Loading />
  </div>
  <div v-else-if="property">
    <BethsLayout :layoutTitle="`Home - ${property.name}`">
      <div>
        <div class="mb-8 lg:mb-12 col-span-1">
          <div class="flex">
            <div class="whitespace-nowrap font-bold text-sectionHdr">Emergency Contacts</div>
            <div class="flex flex-justify-between items-center w-full pl-5">
              <img src="\images\Ellipse.png" alt="" />
              <div class="bg-divider mt-0.5 h-0.5 w-full"></div>
              <img src="\images\Ellipse.png" alt="" />
            </div>
          </div>
        </div>

        <div class="font-normal whitespace-nowrap lg:ml-5 flex flex-wrap">
          <div
            v-for="number in numbers"
            :key="number.numberId"
            class="px-5 mb-2.5 xl:basis-1/4 lg:basis-1/3 md:basis-1/2 basis-full"
          >
            <div class="text-base font-bold">{{ number.label }}</div>
            <div v-if="number.subLabel" class="text-base font-bold">
              {{ number.subLabel }}
            </div>
            <a
              :href="
                (number.emergencyNumber.indexOf('@') >= 0 ? 'mailto:' : 'tel:') +
                number.emergencyNumber
              "
              class="text-smDocs text-link"
            >
              {{ number.emergencyNumber }}
            </a>
          </div>
        </div>
      </div>

      <div v-if="property?.isRespondEnabled" class="pb-8 mt-10 mb-10 rounded-lg w-full">
        <div class="mb-8 col-span-1">
          <div class="flex">
            <div class="whitespace-nowrap font-bold text-sectionHdr">
              <span v-if="customRespondHeader">{{ customRespondHeader.contentValue }}</span>
              <span v-else>Response Steps</span>
            </div>
            <div class="flex flex-justify-between items-center w-full pl-5">
              <img src="\images\Ellipse.png" alt="" />
              <div class="bg-divider mt-0.5 h-0.5 w-full"></div>
              <img src="\images\Ellipse.png" alt="" />
            </div>
          </div>
        </div>

        <!-- Response Scenario buttons -->
        <div
          class="response-panel text-sm pt-3 px-2.5 grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 gap-4"
        >
          <div
            class="response-item-wrapper flex justify-center"
            v-for="(responseType, i) in visibleResponseTypes"
            :key="i"
          >
            <router-link
              :to="RESPONSE_LINK_PREFIX + responseType.systemName"
              class="modal-open font-roboto text-lg text-btn font-normal bg-gray-50 hover:bg-blue-200 md:h-auto pl-5 py-4 md:py-2 w-full border border-gray-300 rounded text-left drop-shadow hover:drop-shadow-xxl"
            >
              {{ responseType.name }}
            </router-link>
            <!--text-white bg-lightblue hover:bg-blue-500-->
          </div>
        </div>
      </div>

      <div v-if="!nothingButResources" class="mb-12 mt-8 col-span-1">
        <div class="flex">
          <div class="whitespace-nowrap font-bold text-sectionHdr">Training and Drills</div>
          <div class="flex flex-justify-between items-center w-full pl-5">
            <img src="/images/Ellipse.png" alt="" />
            <div class="bg-divider mt-0.5 h-0.5 w-full"></div>
            <img src="/images/Ellipse.png" alt="" />
          </div>
        </div>
      </div>
      <div class="flex justify-center w-full">
        <!-- CARDS -->
        <div class="grow">
          <div v-if="nothingButResources">
            <Resources :hide-layout-wrapper="true"></Resources>
          </div>
          <div v-else class="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-11 xl:gap-16">
            <!-- Life Safety Training Button -->
            <router-link v-if="property?.isTrainingEnabled" :to="`/${siteCode}/training/`">
              <!-- 56x40 -->
              <div class="h-72 w-80 rounded-lg shadow-lg ml-auto mr-auto">
                <!-- <img
                  class="lg:hidden rounded-t-lg"
                  src="/images/yellowCardSm1.png"
                  alt=""
                /> -->
                <img class="lg:block rounded-t-lg w-full" src="/images/yellowCard1.png" alt="" />
                <div class="h-1.5 mt-0.5 bg-yellowCard"></div>
                <div class="text-yellowCardSm lg:text-newsm pt-3 px-3.5 lg:pl-8 lg:pr-12">
                  <div class="text-lg text-lightblack font-bold">Life Safety</div>
                  <div class="mt-2.5 font-normal">
                    Fire, medical emergency, bomb threat, earthquake, and other emergency scenarios.
                  </div>
                </div>
              </div>
            </router-link>

            <!-- Launch VR Button -->
            <button v-if="property?.isVrtourEnabled" @click="launchvr" class="ml-auto mr-auto">
              <div class="h-72 w-80 rounded-lg shadow-lg ml-auto mr-auto">
                <!-- <img
                  class="lg:hidden rounded-t-lg"
                  src="/images/yellowCardSm2.png"
                  alt=""
                /> -->
                <img class="block rounded-t-lg w-full" src="/images/yellowCard2.png" alt="" />
                <div class="h-1.5 mt-0.5 bg-yellowCard"></div>
                <div class="text-lg pt-3 px-3.5 pl-7 pr-14">
                  <div class="font-bold text-left">VR Life Safety Platform</div>
                  <!-- <div class="mt-2.5 font-normal text-yellowCardSm text-left">
                    This web VR will show you the best steps to take during a fire using
                    our interactive learning program
                  </div> -->
                </div>
              </div>
            </button>

            <!-- Contacts and Resources separator -->
            <!-- <div class="col-span-1 ml-auto mr-auto" v-if="property?.isStaffDirEnabled">
              <div class="flex">
                <div class="whitespace-nowrap font-bold">Contacts and Resources</div>
                <div class="flex flex-justify-between items-center w-full pl-5">
                  <img src="/images/Ellipse.png" alt="" />
                  <div class="bg-divider mt-0.5 h-0.5 w-full"></div>
                  <img src="/images/Ellipse.png" alt="" />
                </div>
              </div>
            </div> -->

            <!-- Resources and Documents Button -->

            <router-link :to="`/${siteCode}/resources/`" class="ml-auto mr-auto">
              <!-- h-56 w-40 -->
              <div class="h-72 w-80 rounded-lg shadow-lg relative ml-auto mr-auto">
                <img
                  src="/images/iconPaper.png"
                  alt=""
                  class="absolute bottom-36 right-12 w-14 h-20"
                />
                <img class="rounded-t-lg w-full" src="/images/redCard.png" alt="" />
                <div class="h-1.5 mt-0.5 bg-redCard"></div>
                <div class="text-lg text-lightblack font-bold pt-5 pl-8 pr-6">
                  Resources &amp;<br />Documents
                </div>
              </div>
            </router-link>

            <router-link
              v-if="property?.isStaffDirEnabled && userStore.isLoggedIn"
              :to="`/${siteCode}/contacts/`"
              class="ml-auto mr-auto"
            >
              <div class="h-72 w-80 rounded-lg shadow-lg relative ml-auto mr-auto">
                <img
                  src="/images/iconPerson.png"
                  alt=""
                  class="absolute bottom-36 right-12 w-12 h-20"
                />
                <img class="rounded-t-lg w-full" src="/images/redCard.png" alt="" />
                <div class="h-1.5 mt-0.5 bg-redCard"></div>
                <div class="text-lg text-lightblack font-bold pt-5 pl-8 pr-6">Contacts</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </BethsLayout>

    <RespondPopup
      :title="popupLabel"
      :subtitle="selectedRoleName"
      :is-visible="isPopupVisible"
      @close="closePopup"
    >
      <div class="response-steps mb-10" v-html="selectedResponseText" />
      <div class="md:w-96">
        <BaseSelect
          class=""
          label="Show Response Steps for:"
          :options="siteRoleOptions"
          v-model="responseRoleId"
          @update:modelValue="siteRoleChanged"
        />
      </div>
    </RespondPopup>
  </div>
  <div v-else>
    <NotFound />
  </div>
</template>

<script setup lang="ts">
import { useBldgStore } from "../store/bldgStore";
import { useRespondStore } from "../store/respondStore";
import { ContentType, ResponseDTO, ResponseTypeDTO } from "../store/generatedFetchClient";
import { useUserStore } from "../store/userStore";
import Resources from "./Resources.vue";
import router from "../router";
import NotFound from "./NotFound.vue";
import { NameValue } from "../sharedTypes";
import { MetricCaptureNames, useMetrics } from "../helpers/metrics";

const bldgStore = useBldgStore();
const respondStore = useRespondStore();
const userStore = useUserStore();
const metrics = useMetrics();

const RESPONSE_LINK_PREFIX = "#/Responses/";
const siteCode = bldgStore.bldgCode;

var isUserLoadedFromServer = computed(() => userStore.isUserLoadedFromServer);
var user = computed(() => userStore.user);
var isUserLoading = computed(() => userStore.isUserLoading);
var isPropertyLoading = computed(() => bldgStore.isLoading);
var property = computed(() => bldgStore.property);

var customRespondHeader = computed(() =>
  property.value?.content?.find((c) => c.contentType === ContentType.RespondHeader)
);

var visibleResponses = computed(() => {
  if (respondStore?.selectedResponses?.length > 0) {
    let sr = respondStore.selectedResponses;
    if (siteRoleOptions?.value?.length > 0) {
      let responsesByRole = sr.filter((r) => {
        return siteRoleOptions.value.find((o) => o.value === r.siteRoleId);
      });
      return responsesByRole;
    } //else console.warn("No Site Roles Found");
  } //else console.warn("No selected Responses Found");
  return [] as ResponseDTO[];
});
var visibleResponseTypes = computed(() => {
  let types = [] as ResponseTypeDTO[];
  if (property.value?.responseTypes?.length > 0) {
    property.value.responseTypes.filter((t) => {
      if (
        !types.includes(t) &&
        visibleResponses.value.find((r) => r.responseTypeId === t.responseTypeId)
      )
        types.push(t);
    });
  }
  return types;
});
var nothingButResources = computed(
  () => !bldgStore.property?.isVrtourEnabled && !bldgStore.property.isTrainingEnabled
);

// Show section header if there is more than one card in the Training and Drills section
// var moreThanOneTrainingCard = computed(() => {
//   let vr = bldgStore.property?.isVrtourEnabled ?? false;
//   let prepare = bldgStore.property?.isTrainingEnabled ?? false;

//   return vr && prepare;
// });

let isLoading = ref(false);

loadData();
onUpdated(() => loadData);
onActivated(() => loadData);

onMounted(() => loadData);

watch(property, loadData);
async function loadData() {
  console.log("Home page loaded");
  isLoading.value = true;
  if (property?.value?.portalId) {
    await redirectIfNotLoggedIn();
    if (tryAutoLaunchVr()) return;
    if (!bldgStore.linkSections?.length) await bldgStore.getLinks(property.value.portalId);
    if (!visibleResponses.value?.length)
      await respondStore.getResponsesByPortal(property.value.portalId);

    checkURLResponseLink();
  }
  isLoading.value = false;
}

watch(isUserLoadedFromServer, redirectIfNotLoggedIn);
watch(user, redirectIfNotLoggedIn);
async function redirectIfNotLoggedIn() {
  // For portals with hideAllAnonymousContent = true:
  // If user loading attempt is complete and we're still not logged in, redirect to login page

  if (!isUserLoadedFromServer.value && !isUserLoading.value)
    await userStore.getUser(property.value.siteCode, property.value.portalId, true);

  let currentRoute = router.currentRoute.value.path;

  if (
    property.value &&
    property.value.hideAllAnonymousContent &&
    !isUserLoading.value &&
    !userStore.isLoggedIn
  ) {
    console.log(`Redirecting to login page (isLoggedIn = ${userStore.isLoggedIn})`);
    router.push(`/${property.value.siteCode}/login?returnUrl=${currentRoute}`);
  }

  if (
    property.value &&
    property.value.hideAllAnonymousContent &&
    !isUserLoading.value &&
    !userStore.isEmailVerifiedOrNotRequired
  ) {
    console.log(
      `Redirecting to email unconfirmed page page (isEmailVerifiedOrNotRequired = ${userStore.isEmailVerifiedOrNotRequired})`
    );
    router.push(`/${siteCode}/unconfirmedemail?returnUrl=${currentRoute}`);
  }
}

let currentQuery = computed(() => router.currentRoute.value.query);
watch(currentQuery, checkURLResponseLink);
watch(visibleResponseTypes, checkURLResponseLink);
function checkURLResponseLink() {
  let routerHash = router.currentRoute.value.hash;

  if (routerHash.indexOf(RESPONSE_LINK_PREFIX) >= 0) {
    let responseLink = routerHash?.substring(RESPONSE_LINK_PREFIX.length).toLocaleLowerCase();

    if (responseLink) {
      let selectedResponse = visibleResponseTypes.value.find(
        (t) => t.systemName.toLocaleLowerCase() === responseLink
      );

      if (selectedResponse) openResponse(selectedResponse);
    }
  }
}

watch(isPropertyLoading, () => {
  if (isPropertyLoading.value == false && !property.value) {
    console.log(`Property doesn't exist`);
  }
});

var numbers = computed(() => {
  let numbers = bldgStore.property.numbers;
  if (userStore.isLoggedIn && userStore.isEmailVerifiedOrNotRequired) {
    var filteredNumbers = numbers.filter((n) => {
      return n.siteRoles.find((r) => {
        return r.siteRoleId == userStore.user.siteRoleId;
      });
    });
    return filteredNumbers;
  } else {
    var anonNumbers = numbers.filter((n) => n.allowAnonView);
    return anonNumbers;
  }
});

// popup stuff
var isPopupVisible = ref(false);
var popupLabel = ref("");
var selectedResponseText = computed(() => {
  let roleId =
    typeof responseRoleId.value === "string"
      ? parseInt(responseRoleId.value)
      : responseRoleId.value;

  let selectedResponse = visibleResponses.value.find(
    (r) => r.responseTypeId === responseTypeId.value && r.siteRoleId === roleId
  );

  if (!selectedResponse) {
    console.warn(
      `No response found for role: ${roleId} and typeId: ${responseTypeId.value}.`,
      visibleResponses.value
    );
    return "<p class='mb-8'>No response steps for this role.</p>";
  }

  //Insert download tokens into links
  let token = userStore.authToken;
  let htmlString = selectedResponse?.responseText;
  if (token && htmlString) {
    htmlString = htmlString.replaceAll('/download"', "/download?token=" + token + '"');
  }

  return htmlString;
});
var siteRoleOptions = computed(() =>
  property.value.siteRoles
    ?.filter((s) => {
      if (s.isStaffRole) return userStore.isLoggedIn && userStore.user.isStaffRole;
      return true;
    })
    ?.map((s) => ({ name: s.roleAlias, value: s.siteRoleId } as NameValue))
);
var closePopup = () => {
  router.replace(`/${property.value.siteCode}`);
  isPopupVisible.value = false;
};
var responseTypeId = ref(0);
var responseRoleId = ref<string | number>(0);
let selectedRoleName = computed(() => {
  let roleId =
    typeof responseRoleId.value === "string"
      ? parseInt(responseRoleId.value)
      : responseRoleId.value;

  //console.log("Switching role to " + roleId);
  if (Number.isSafeInteger(roleId)) {
    if (property?.value?.siteRoles.length > 0) {
      let role = property.value.siteRoles.find((r) => r.siteRoleId === roleId);

      return role?.roleAlias ?? "";
    }
  }
  return "";
});

function openResponse(responseType: ResponseTypeDTO) {
  console.log("click on response " + responseType.name);
  let currentRoute = router.currentRoute.value;

  // If we're not logged in
  //  and portal does not allow anonymous viewing of Responses,
  // then redirect to login page
  if (!userStore.isLoggedInToPortal(property.value.siteCode) && !property.value.respondAnonView) {
    router.push(
      `/${property.value?.siteCode}/login?returnUrl=${currentRoute.path}${currentRoute.hash}`
    );
    return;
  }

  if (!userStore.isEmailVerifiedOrNotRequired && !property.value.respondAnonView) {
    router.push(`/${siteCode}/unconfirmedemail?returnUrl=${currentRoute.path}${currentRoute.hash}`);
  }

  popupLabel.value = responseType.name;
  responseTypeId.value = responseType.responseTypeId;
  responseRoleId.value = userStore.isLoggedIn
    ? userStore.user.siteRoleId
    : siteRoleOptions.value[0]?.value;
  isPopupVisible.value = true;

  metrics.capture(MetricCaptureNames.ViewRespondContent);
}

function siteRoleChanged(newSiteRoleId: number) {
  console.log("Site Role Id", newSiteRoleId);

  const selectedRole = siteRoleOptions.value.find((role) => role.value === newSiteRoleId);

  metrics.capture("siteRoleChanged", {
    newRoleId: newSiteRoleId,
    newRoleName: selectedRole ? selectedRole.name : "Unknown",
  });
}

watch(user, tryAutoLaunchVr);

// If Back from VR restores this page from the browser's back-forward cache, the
// early return in loadData left the spinner on; clear it so Home renders.
function onPageShow(e: PageTransitionEvent) {
  if (e.persisted) isLoading.value = false;
}
onMounted(() => window.addEventListener("pageshow", onPageShow));
onUnmounted(() => window.removeEventListener("pageshow", onPageShow));
// Portal setting "Launch VR immediately on login": right after login, send non-admin users
// straight into the VR tour in the current window. Flag is one-shot, so returning to Home won't loop.
function tryAutoLaunchVr(): boolean {
  if (!userStore.pendingVrAutoLaunch) return false;
  if (!property.value?.portalId || isUserLoading.value) return false; // wait until loaded

  userStore.pendingVrAutoLaunch = false;
  if (
    property.value.isVrtourEnabled &&
    property.value.launchVrOnLogin &&
    userStore.isLoggedIn &&
    userStore.isEmailVerifiedOrNotRequired &&
    !userStore.isAdmin &&
    userStore.user?.personId
  ) {
    console.log("Auto-launching VR on login");
    location.assign(`/api/launch/starttour/${siteCode}/${userStore.user.personId}`);
    return true;
  }
  return false;
}

function launchvr() {
  if (userStore.isLoggedIn) {
    if (userStore.isEmailVerifiedOrNotRequired) {
      console.log("Launching VR: ", `/api/launch/starttour/${siteCode}/${userStore.user.personId}`);
      window.open(`/api/launch/starttour/${siteCode}/${userStore.user.personId}`, "_blank");
    } else {
      router.push(`/${siteCode}/unconfirmedemail`);
    }
  } else {
    router.push(`/${siteCode}/login`);
  }
}
</script>

<style scoped>
.response-steps {
  font-size: medium;
}

.response-steps :deep(a) {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.response-steps :deep(a:hover) {
  color: cornflowerblue;
}

.response-steps :deep(ul) {
  padding-left: 24px;
}

.response-steps :deep(ul > li) {
  font-weight: normal;
  list-style-type: circle;
}

.response-steps :deep(ol) {
  counter-reset: li;
  margin-left: 0;
  padding-left: 0;
}

.response-steps :deep(ol > li) {
  position: relative;
  margin: 0 0 2px 2em;
  padding: 0 8px;
  list-style: none;
}

.response-steps :deep(ol > li:before) {
  content: counter(li);
  counter-increment: li;
  position: absolute;
  top: 0px;
  left: -1em;
  box-sizing: border-box;
}

.response-steps :deep(h2) {
  font-size: x-large;
}

.response-steps :deep(h3) {
  font-size: larger;
}

.response-steps :deep(h4) {
  font-size: large;
}
</style>
